export const PropertyOnlyCategory = 'property-only';
export const CONTACT_FQN = 'contact';
export const COMPANY_FQN = 'company';
export const DEAL_FQN = 'deal';
export const TICKET_FQN = 'ticket';
export const LINE_ITEM_FQN = 'line_item';
export const QUOTE_FQN = 'quote';
export const SUBSCRIPTION_FQN = 'subscription';
export const FEEDBACK_SUBMISSION_FQN = 'feedback_submission';
export const PAYMENT_FQN = 'payment';
export const GOAL_TARGET_FQN = 'goal_target';
export const PropertyCategories = {
  CONTACT: CONTACT_FQN,
  COMPANY: COMPANY_FQN,
  PRIMARY_COMPANY: 'primary_company',
  DEAL: DEAL_FQN,
  LINE_ITEM: LINE_ITEM_FQN,
  SITE_SETTINGS: 'site_settings',
  SUBSCRIPTION_TYPE: 'subscription_type',
  TICKET: TICKET_FQN,
  QUOTE: QUOTE_FQN,
  FEEDBACK_SUBMISSION: FEEDBACK_SUBMISSION_FQN,
  CONVERSATION: 'conversation',
  SUBSCRIPTION: SUBSCRIPTION_FQN
};
export const PropertyOnlyTokenToCategory = {
  subscription_name: 'subscription_type'
};
export const CUSTOM_EVENT_CATEGORY = 'custom_event';
export const USER_PROPERTY_TYPE = 'OWNER';
export const HUBSPOT_OWNER_PROPERTY_NAME = 'hubspot_owner_id';
export const HUBSPOT_OWNER_FIRST_NAME = `${HUBSPOT_OWNER_PROPERTY_NAME}.firstname`;
export const HUBSPOT_OWNER_LAST_NAME = `${HUBSPOT_OWNER_PROPERTY_NAME}.lastname`;
export const HUBSPOT_OWNER_FULL_NAME = `${HUBSPOT_OWNER_PROPERTY_NAME}.fullname`;